import React from 'react';

interface ActorProps {
    name: string;
    role: string;
    backgroundImage: string;
    url: string;
    tabIndex?: number;
}

class Actor extends React.Component<ActorProps> {
    render(): React.ReactElement {
        const { name, role, url, backgroundImage, tabIndex } = this.props;

        return (
            <a
                href={url}
                className="link"
                tabIndex={tabIndex}
                aria-label={`${name}, ${role}`}
            >
                <div
                    className="gallery-card"
                    style={{
                        backgroundImage,
                    }}
                    aria-hidden="true"
                >
                    <h4 className="gallery-card__title">{name}</h4>
                    <div className="gallery-card__subtitle">{role}</div>
                </div>
            </a>
        );
    }
}

export default Actor;
